import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guard/auth.guard';

const financeRoutes: Routes = [
    { path: 'finance/tariffs',      loadChildren: () => import('./tariffs/tariffs.module').then(m => m.TariffsPageModule),
        canActivate: [AuthGuard] },
    { path: 'finance/payments',     loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsPageModule),
        canActivate: [AuthGuard] },
    { path: 'finance/reports',      loadChildren: () => import('./reports/reports.module').then(m => m.ReportsPageModule),
        canActivate: [AuthGuard] },
    { path: 'order/success',        loadChildren: () => import('./order/order.module').then(m => m.OrderPageModule) },
    { path: 'order/fail',           loadChildren: () => import('./order/order.module').then(m => m.OrderPageModule) },
    { path: 'order/waiting',        loadChildren: () => import('./order/order.module').then(m => m.OrderPageModule) }
];

@NgModule({
    imports: [RouterModule.forChild(financeRoutes)],
    exports: [RouterModule]
})
export class FinanceRoutingModule {
}
